<template>
  <header 
    class="header" 
    :style="{ backgroundColor: envConfig.headerBackgroundColor }"
  >
    <h1 class="tit">
      <router-link to="/request">
        <img
          src="../assets/images/logo-eaglem.svg"
          alt="Eagle M"
        />
        <span 
          v-if="envConfig.isStaging" 
          class="staging-badge"
        >Staging</span>
      </router-link>
    </h1>
    <nav class="main-nav">
      <router-link 
        :to="`/${item}`"
        class="nav-item" 
        v-for="item in menuList" 
        :key="item"
        :class="{ current: currentItem === item }"
        @click="currentItem = item"
      >
        <div class="nav-img">
          <img 
            :src="require(`@/assets/images/nav-icons/icon-${item}.svg`)" 
            :alt="item"
          >
        </div>
        <div class="nav-text">
          {{ item }}
        </div>
      </router-link>
    </nav>
    <div class="login">
      <span class="text"><b>{{useStore.user?.userId }}</b>님</span>
      <el-button
        size="small"
        color="#555555"
        class="btn-logout"
        aria-label="Logout"
        @click="handleLogout()"
      >
        <font-awesome-icon icon="right-to-bracket" />
      </el-button>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { removeAuthToken } from '@/utils/auth'
import { useUserStore } from '@/stores/user'
import { ElNotification } from 'element-plus'
import { getEnvironmentConfig } from '@/utils/environment'

const router = useRouter();
const route = useRoute();
const useStore = useUserStore();


// 환경 설정 가져오기
const envConfig = computed(() => getEnvironmentConfig());


// console.log(envConfig.value);

const menuList = [
  'request',
  'customer'
]
const currentItem = ref('request')

watch(route, () => {
  currentItem.value = route.path.split('/')[1]
})
const handleLogout = () => {
  removeAuthToken();
  ElNotification({
    title: '성공',
    message: '정상적으로 로그아웃 되었습니다.',
    type: 'success',
    duration: 1500
  });
  router.push({ name: 'Login' });
}
</script>

<style lang="scss" scoped>
nav.main-nav {
  display: flex;
  color: #fff;
  height: 100%;
  .nav-item {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    GAP: 4px;
    max-width: 80px;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    opacity: .5;
    .nav-img {
      width: 24px;
      aspect-ratio: 1;

      img {
        width: 100%;
      }
    }
    .nav-text {
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
    }
    &.current {
      background-color: var(--c-primary);
      opacity: 1;
    }
    &:hover {
      opacity: 1;
    }
  }
}
</style>